import { InfoOutlined } from "@mui/icons-material";
import { Box, Typography, useTheme } from "@mui/material";
import { FC } from "react";
import { Tooltip } from "../../../components";
import { useLocalization } from "../../../hooks/useLocalization";
import { EditButton } from "../components/EditButton";

export const SeatsView: FC<{ seats?: number; onClick?: () => void }> = ({
  seats,
  onClick,
}) => {
  const { t } = useLocalization();
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography
        sx={{
          fontWeight: 500,
          fontSize: 14,
          color: theme.colors.text[5],
        }}
      >
        {seats ?? t("licenses.unlimited")}
      </Typography>
      {seats ? (
        <EditButton onClick={onClick} />
      ) : (
        <Tooltip message={t("licenses.seatsTooltip")} placement="right">
          <InfoOutlined
            sx={{
              fontSize: 18,
              color: theme.colors.secondary[6],
            }}
          />
        </Tooltip>
      )}
    </Box>
  );
};
